import {Component} from "../Component.js";
import {Toast} from "../Toast.js";
import {createLogger} from "../../util/logger.js";

const console = createLogger("CommunityCard");

/**
 * Manages features for community card.
 * Mainly submitting request to generate card and redirecting to its landing page
 *
 */
export class CommunityCard extends Component {
    static name = "community-card";

    get name() {
        return CommunityCard.name;
    }

    constructor(el) {
        super(el);

        /**
         * @type {HTMLElement}
         */
        this.$form = this.querySelector("form");

        /**
         * @type {boolean}
         */
        this.formPending = false;

        if (this.$form) {
            this.addEventListener(this.$form, "submit", this.onSubmitForm.bind(this));
        }

        console.log(this);
    }


    /**
     *
     * @param {SubmitEvent} e
     * @return {Promise<void>}
     */
    async onSubmitForm(e) {
        e.preventDefault();

        if (this.formPending) return;

        const data = new FormData(this.$form);

        const submitter = e.submitter;
        const platform = submitter.getAttribute("value");

        console.log("onSubmitForm", {submitter, platform});

        // If landing page was not fetched already submit the form
        if (!this.response) {
            this.formPending = true;
            this.el.classList.add("loading");
            this.$form.classList.add("form--pending");
            this.response = await fetch(this.$form.getAttribute("action"), {
                method: this.$form.getAttribute("method"),
                body: data,
            }).then(res => res.json()).then(/** @param {{error?: object, message?: string|null, details?: object|null}} res */res => {
                if (res.error) {
                    Toast.showToast(res.error.message, "error", 3000);
                } else if (res.message) {
                    Toast.showToast(res.message, "success", 3000);
                }

                return res;
            }).finally(() => {
                this.$form.classList.remove("form--pending");
                this.el.classList.remove("loading");
                this.formPending = false;
            });
        }

        console.log(this);

        if (this.response?.details?.platformUrls?.hasOwnProperty(platform)) {
            const url = this.response.details.platformUrls[platform];
            console.log("URL", url);
            window.open(url, "_blank");
        }
    }



}
